<template>
  <div v-if="errors[name]!=undefined">
    <slot></slot>
    <div class="text-neutral-100 bg-rose-500 leading-none p-1 rounded text-wrap">
      {{ getError() }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['errors', 'name'],
  methods: {
    getError: function () {
      return this.errors[this.name][0];
    }
  }
}
</script>
